import React from 'react'
import ReportHeader from '../../../common/ReportHeader'
import { Box } from '@mui/material'
import LinkPlaceFilters from './LinkPlaceConfigFilters'
import { useDispatch } from 'react-redux'
import { masterConfigMenuVSBL } from '../../../../redux/Actions'

const ViewLinkPlaceConfig = (props) => {
  const dispatch = useDispatch()
  const { data, handleView } = props
  return (
    <Box className='masterConfig_container'>
      <ReportHeader headerName={'Link Place Configuration'} subHeader={"View Link Place"} mainHeaderName="Master Configuration" openSubMenu={() => dispatch(masterConfigMenuVSBL(true))} fixedTopPosition={true} />
      <LinkPlaceFilters handleBack={handleView} data={data} isView={true} />
    </Box>
  )
}

export default ViewLinkPlaceConfig
